// Module
var code = `<div id="modal-window-container-ui">
  <div id="modal-window-container-header">
    <button
      class="modal-btn modal-close-btn"
      data-btn-type="modal"
      data-open-modal="false"
    >
        <svg width="28pt" height="28pt" version="1.1" viewBox="0 0 128 128" xmlns="http://www.w3.org/2000/svg">
            <path d="m104 12h-80c-6.6016 0-12 5.3984-12 12v80c0 6.6016 5.3984 12 12 12h80c6.6016 0 12-5.3984 12-12v-80c0-6.6016-5.3984-12-12-12zm-17.16 69.16c1.5586 1.5586 1.5586 4.1211 0 5.6797-0.80078 0.76172-1.8398 1.1602-2.8398 1.1602-1.0391 0-2.0391-0.39844-2.8398-1.1602l-17.16-17.199-17.16 17.199c-0.80078 0.76172-1.8008 1.1602-2.8398 1.1602s-2.0391-0.39844-2.8398-1.1602c-1.5586-1.5586-1.5586-4.1211 0-5.6797l17.199-17.16-17.199-17.16c-1.5586-1.5586-1.5586-4.1211 0-5.6797s4.1211-1.5586 5.6797 0l17.16 17.199 17.16-17.199c1.5586-1.5586 4.1211-1.5586 5.6797 0s1.5586 4.1211 0 5.6797l-17.199 17.16z"/>
        </svg>

    </button>
  </div>
</div>

<div id="modal-window-container-holder"></div>
<div id="modal-window-bg"></div>
`;
// Exports
module.exports = code;